import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';

import { styledCustom } from '/styles';
import { headerHeight } from '/common/Header/styles';

export const NavbarContainer = styled('div')`
  background-color: ${({ theme }) => (theme.palette.mode === 'dark' ? '#383838' : '#fafafa')};
  border-inline-end: 1px solid ${grey[400]};
  padding: 8px;
  position: relative;
`;
export const NavbarItem = styledCustom('div')<{ $background?: boolean; $disabled?: boolean }>(
  ({ theme, $background, $disabled }) => ({
    cursor: $disabled ? 'not-allowed' : 'pointer',
    opacity: $disabled ? 0.5 : 1,
    pointerEvents: $disabled ? 'none' : 'auto',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 8,
    borderRadius: 8,
    height: 34,
    marginBottom: 8,
    '& > p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    },
    '& .hover-icon': {
      position: 'absolute',
      right: 14,
      opacity: 0,
      visibility: 'hidden',
      transition: 'opacity 0.2s ease, visibility 0.2s ease',
      padding: '2px',
      borderRadius: '2px',
      color: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#356d8e',
      '&:hover': {
        color: theme.palette.action.active,
        backgroundColor: 'transparent',
      },
    },

    '&[data-selected="true"]': {
      backgroundColor: $background ? (theme.palette.mode === 'dark' ? '#525252' : '#D8E7F6') : '',
      '& > p': {
        fontWeight: 500,
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark' ? grey[700] : '#CEE6FD',
      '& > p': {
        width: '90%',
      },
      '& .hover-icon': {
        opacity: 1,
        visibility: 'visible',
      },
    },
  })
);

export const chatsHeadersHeight = 222;
export const heightHeaderPadding = headerHeight + 17;
export const ChatsContent = styledCustom('div')<{ $showRightPanel?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $showRightPanel }) => ($showRightPanel ? '250px 1fr 400px' : '250px 1fr')};
  border-top: 1px solid ${grey[400]};
height: calc(100vh - ${chatsHeadersHeight + heightHeaderPadding}px);

`;
